import { Toast } from "antd-mobile";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { coinApi } from "../../api/coin-api";
import { financeApi } from "../../api/finance-api";
import TopBar from "../../components/topBar";
import TopBar2 from "../../components/topBar2";
import { getText } from "../../utils/util";
import ListPage from "./components/listPage";
import { AcendexLayout } from "@/components/acendex/components/layout/AcendexLayout";
// import TopPage from "./components/topPage";

export default function AddressList() {
  const navigate = useNavigate();
  const uid = localStorage.getItem("uid");
  const [addressList, setAddressList] = useState([] as any[]);
  const [coinList, setCoinList] = useState([] as any[]);
  const { t: translate } = useTranslation();
  //加载数据
  const loadData = async () => {
    loadAddressData();
    loadCoinData();
  };

  //加载地址
  const loadAddressData = async () => {
    const data = await financeApi.list({ uid });
    if (data.ok) {
      setAddressList(data.data);
    }
  };

  //加载种类
  const loadCoinData = async () => {
    const data = await coinApi.list();
    if (data.ok) {
      setCoinList(data.data);
    }
  };

  //添加地址
  const addAddress = async (address) => {
    const data = await financeApi.add({ uid, ...address });
    if (data.ok) {
      Toast.show({
        content: translate(getText("操作成功")),
      });
    } else {
      Toast.show({
        content: translate(getText("系統錯誤")),
      });
    }
    loadAddressData();
  };
  //删除 地址
  const delAddress = async (id) => {
    const data = await financeApi.del({ id });
    if (data.ok) {
      Toast.show({
        content: translate(getText("操作成功")),
      });
    } else {
      Toast.show({
        content: translate(getText("系統錯誤")),
      });
    }
    loadAddressData();
  };

  useEffect(() => {
    loadData();
  }, []);
  return (
    <div className="w-full h-dvh bg-neutral-900 revert-style">
      <AcendexLayout theme="light" hideBottomBar mobileTopBarTitle={translate(getText("地址管理"))} pcTopBarTitle={translate(getText("地址管理"))}>
        <div className="w-full max-w-4xl mx-auto px-4 py-6">
          <div className="bg-neutral-800 bg-opacity-50 backdrop-blur-sm rounded-xl mb-6 p-4 shadow-md">
            <div className="flex items-center mb-4">
              <div className="w-10 h-10 rounded-full bg-primary flex items-center justify-center mr-3">
                <svg className="w-5 h-5 text-white" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" fill="currentColor"/>
                </svg>
              </div>
              <h1 className="text-xl font-medium text-white">{translate(getText("钱包地址管理"))}</h1>
            </div>
            <p className="text-neutral-400 text-sm mb-2">{translate(getText("管理您的加密货币钱包地址"))}</p>
          </div>
          <ListPage addressList={addressList} delAddress={delAddress} coinList={coinList} />
        </div>
      </AcendexLayout>
    </div>
  );
}
